import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import PropTypes from "prop-types";

import SiteIcons from "@/components/SiteIcons/SiteIcons";

function UsersTableRow({ individual, editRecord, deleteRecord }) {
  return (
    <TableRow>
      <TableCell>{individual.name}</TableCell>
      <TableCell>{individual.email}</TableCell>
      <TableCell>{individual.role}</TableCell>
      <TableCell>
        <SiteIcons
          iconstring="edit-outlined"
          page="users"
          color="gray"
          onClick={() => editRecord(individual)}
        />
        <SiteIcons
          page="users"
          color="gray"
          iconstring="delete-outlined"
          onClick={() => deleteRecord(individual)}
        />
      </TableCell>
    </TableRow>
  );
}

UsersTableRow.propTypes = {
  individual: PropTypes.object,
  editRecord: PropTypes.func,
  deleteRecord: PropTypes.func,
};

export default UsersTableRow;
